import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiLabelUsedIn(elementId: any, type: any): Promise<any> {
    return getFetch(`${API_SERVERLESS}/backOffice/v2/used/${type}/${elementId}/3`, true);
}
